






















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import sumFilter from "fs-pb-vue2/filters/sum.filter";

@Component({
  components: { BackLink }
})

export default class ArrestDetails extends Vue {
  @Prop() details!: string;
  @Prop() currency!: string;

  selectedDocument: any = null;

  get parsedDetails() {
    if (!this.details) return [];

    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(this.details, "text/xml");
      const documents = xmlDoc.getElementsByTagName("document");

      return Array.from(documents).map(doc => ({
        id: doc.getAttribute("id") || "",
        reason: doc.getAttribute("reason") || "",
        totalSum: sumFilter(doc.getAttribute("totalSum"), false, this.currency) || "",
        unpaidSum: sumFilter(doc.getAttribute("unpaidSum"), false, this.currency) || "",
        collector: doc.getAttribute("collector") || "",
        documentCreatedDate: doc.getAttribute("documentCreatedDate") || "",
        documentReceiptDate: doc.getAttribute("documentReceiptDate") || ""
      }));
    } catch (error) {
      console.error("Ошибка парсинга XML:", error);
      return [];
    }
  }

  // Сортируем по дате (от новых к старым)
  get sortedDetails() {
    return this.parsedDetails.sort((a, b) => {
      const dateA = this.parseDate(a.documentCreatedDate);
      const dateB = this.parseDate(b.documentCreatedDate);
      return dateB - dateA;
    });
  }

  // Преобразование даты
  parseDate(dateString: string): number {
    const [day, month, year] = dateString.split(".").map(Number);
    return new Date(year, month - 1, day).getTime(); 
  }

  // Выбор документа (открытие деталей)
  selectDocument(document: any) {
    this.selectedDocument = document;
  }

  // Возврат к списку документов
  handleBack() {
    if (this.selectedDocument) {
      this.selectedDocument = null;
    } else {
      this.$router.back();
    }
  }
}
